import type { IconDefinition } from '../../types'

export default {
  details: [20, 20, [], '', 'M17 1H3C1.89543 1 1 1.89543 1 3V17C1 18.1046 1.89543 19 3 19H17C18.1046 19 19 18.1046 19 17V3C19 1.89543 18.1046 1 17 1ZM3 0C1.34315 0 0 1.34315 0 3V17C0 18.6569 1.34315 20 3 20H17C18.6569 20 20 18.6569 20 17V3C20 1.34315 18.6569 0 17 0H3Z'],
  name: 'uiCheckboxUnselected',
  oldName: 'cuiCheckboxUnselected',
	pathProps: { fillRule: 'evenodd', clipRule: 'evenodd' }
} as IconDefinition
